import { useEffect } from "react"
import { useAppDispatch, useAppSelector } from "../../../../lib/redux/hooks"
import { ButtonComponent } from "../../../../ui/molecules/button/newButton"
import { MadfarmInput } from "../../../../ui/molecules/input/newInput"
import { MadfarmStaticSelect } from "../../../../ui/molecules/select/newSelect/static"
import TextArea from "../../../../ui/molecules/textArea"
import { ServiceTypeUnitOptions } from "../../../../utils"
import { ServiceTypeCreation, setSTCreationAmountPerUnit, setSTCreationBillingWorksheetId, setSTCreationCategory, setSTCreationCode, setSTCreationDescription, setSTCreationNote, setSTCreationUnitType } from "../../slice"
import { ServiceTypeCategoryEnum } from "../../dataService/dto"

interface Props {
    close: () => void
    isAdditional: boolean
    billingWorksheetId: string
}

export function ServiceTypePopupAdd(props: Props) {
    const dispatch = useAppDispatch()
    const serviceTypeState = useAppSelector(state => state.billingAndServiceType)

    useEffect(() => {
        dispatch(setSTCreationCategory(props.isAdditional ? 
            ServiceTypeCategoryEnum.SPESA_AGGIUNTIVA : 
            ServiceTypeCategoryEnum.SERVIZIO))
        dispatch(setSTCreationBillingWorksheetId(props.billingWorksheetId))
    }, [])

    useEffect(() => {
        if(serviceTypeState.serviceTypeCreationStatus === 'successfully') {
            props.close()
        }
    }, [serviceTypeState.serviceTypeCreationStatus])

    return (
        <div className="px-6 py-5 flex flex-col gap-5">
            <MadfarmInput
                label="Codice"
                placeholder="Specifica codice..."
                value={serviceTypeState.serviceTypeCreationRequest.code}
                onChangeText={(text) => dispatch(setSTCreationCode(text))}
            />

            <TextArea
                label="Descrizione"
                placeholder="Specifica descrizione..."
                value={serviceTypeState.serviceTypeCreationRequest.description}
                onChangeText={(text) => dispatch(setSTCreationDescription(text))}
            />

            {!props.isAdditional && (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <MadfarmStaticSelect
                        label="Unità di Calcolo"
                        placeholder="Seleziona unità..."
                        options={ServiceTypeUnitOptions}
                        value={serviceTypeState.serviceTypeCreationRequest.unitType}
                        onChange={(value) => {
                            // @ts-ignore
                            const newValue = value !== null ? value.value : null
                            dispatch(setSTCreationUnitType(newValue))
                        }}
                        noOptionsMessage=""
                    />
                    <MadfarmInput
                        label="Importo"
                        placeholder="Specifica importo..."
                        value={serviceTypeState.serviceTypeCreationRequest.amountPerUnit?.toString()}
                        onChangeText={(text) => dispatch(setSTCreationAmountPerUnit(text))}
                    />
                </div>
            )}

            <TextArea
                label="Note"
                placeholder="Aggiungi note..."
                value={serviceTypeState.serviceTypeCreationRequest.note}
                onChangeText={(text) => dispatch(setSTCreationNote(text))}
            />

            <div className="flex justify-end">
                <ButtonComponent
                    variant="solid"
                    color="orange"
                    size="md"
                    iconPosition="off"
                    label="Salva"
                    onClick={() => dispatch(ServiceTypeCreation(serviceTypeState.serviceTypeCreationRequest))}
                />
            </div>
        </div>
    )
}